// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"cbc6a603","268":"60470187","272":"05a5cc0b","333":"4990bdb7","501":"1c223090","596":"828b0b97","597":"54fcd2e0","656":"c015ddc3","765":"cbc4e754","843":"b4d0e93c","934":"92a2e396","947":"28360e17","963":"bf4285f9"}[chunkId] + ".chunk.js";
};